import { useTheme } from '@mui/material'

export const useIsDarkMode = () => useTheme().palette.mode === 'dark'
